/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeveloperService } from '../../developer/services/developer.service';
import { TestCasePresentation } from '../models/test-case-presentation';
import { CurrentUserService } from '../../user/services';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { TestToolService } from '../services/test-tool.service';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxiColumnModule, DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

export interface TestToolRunTestCasesDialogResult {
    casesToRun: TestCasePresentation[];
    comment: string | undefined;
}

@Component({
    templateUrl: './test-tool-run-test-cases-dialog.component.html',
    styleUrls: ['./test-tool-run-test-cases-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, DxDataGridModule, BizDataGridDirective, DxiColumnModule, DxiValidationRuleModule, DxTemplateModule]
})
export class TestToolRunTestCasesDialogComponent implements OnInit {
    public developerService = inject(DeveloperService)

    private activeModal = inject(NgbActiveModal)
    private fb = inject(UntypedFormBuilder)
    private currentUserService = inject(CurrentUserService)
    private loadingPanelService = inject(LoadingPanelService)
    private testToolService = inject(TestToolService)
    private toastService = inject(ToastService)
    
    form = this.fb.group({
        testCases: null,
        comment: ''
    });

    comment: '';
    allowRunning = false;
    testCases: TestCasePresentation[] = [];
    selectedTestCases: TestCasePresentation[] = [];
    selectAllCheckBox: any;
    checkBoxUpdating = false;

    ngOnInit(): void {
        void this.refresh();
        this.allowRunning = this.currentUserService.hasPermission('TestTool_Action_TestCase_Run');
    }

    async refresh(): Promise<void> {
        try {
            setTimeout(() => {
                this.loadingPanelService.showLoadingPanelDirect('Loading...');
            });

            await Promise.all([
                this.testToolService.getTestCases().then(result => {
                    this.testCases = result.map(testCase => ({
                        ...testCase,
                        PreRunValidationDescription: testCase.PreRunValidationDescription ?? 'Ready'
                    }));
                }),
            ]);
        }
        catch (err) {
            console.error(err);
            this.toastService.showToast('Failed to load data...', ToastType.error);
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    ok(): void {
        if (this.allowRunning) {
            const result: TestToolRunTestCasesDialogResult = {
                casesToRun: this.selectedTestCases,
                comment: this.comment
            };
            this.activeModal.close(result);
        }
    }

    cancel(): void {
        const result: TestToolRunTestCasesDialogResult = {
            casesToRun: [],
            comment: undefined
        };
        this.activeModal.close(result);
    }

    onSelectionChanged = (e: any) => {
        const deselectRowKeys = [];
        e.selectedRowsData.forEach((item) => {
            if (!this.isSelectable(item as TestCasePresentation))
                deselectRowKeys.push(e.component.keyOf(item));
        });
        if (deselectRowKeys.length) {
            e.component.deselectRows(deselectRowKeys);
        }
        this.checkBoxUpdating = true;
        this.selectAllCheckBox.option('value', this.isSelectAll(e.component));
        this.checkBoxUpdating = false;

        this.selectedTestCases = e.selectedRowsData;
    }

    onEditorPreparing = (e) => {
        const dataGrid = e.component;
        if (e.command === 'select') {
            if (e.parentType === 'dataRow' && e.row) {
                if (!this.isSelectable(e.row.data as TestCasePresentation))
                    e.editorOptions.disabled = true;
            } else if (e.parentType === 'headerRow') {
                e.editorOptions.onInitialized = (e) => {
                    this.selectAllCheckBox = e.component;
                }
                e.editorOptions.value = this.isSelectAll(dataGrid);
                e.editorOptions.onValueChanged = (e) => {
                    if (!e.event) {
                        if (e.previousValue && !this.checkBoxUpdating) {
                            e.component.option('value', e.previousValue);
                        }
                        return;
                    }
                    if (this.isSelectAll(dataGrid) === e.value) {
                        return;
                    }
                    e.value ? dataGrid.selectAll() : dataGrid.deselectAll();
                    e.event.preventDefault();
                }
            }
        }
    }

    isSelectAll = (dataGrid: any): boolean | undefined => {
        const items = this.testCases;
        const selectableItems = items.filter(this.isSelectable);
        const selectedRowKeys = dataGrid.option('selectedRowKeys');
    
        if (!selectedRowKeys.length) {
            return false;
        }
        return selectedRowKeys.length >= selectableItems.length ? true : undefined;
    }

    isSelectable(item: TestCasePresentation) {
        return item.PreRunValidationDescription === 'Ready';
    }

    commentChanged(e: any) {
        this.comment = e;
    }
}
